import React from 'react';
import Container from './Container';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface SplitPageTitleProps {
  title: string;
  subtitle?: string;
  sx?: SxProps<Theme>;
  subtitleStyle?: SxProps<Theme>;
  fullWidth?: boolean;
  backButtonSlot?: React.ReactNode;
}

const SplitPageTitle: React.FC<SplitPageTitleProps> = ({ sx, title, subtitle = '', fullWidth, subtitleStyle, backButtonSlot }) => {
  const Wrapper = fullWidth ? Box : Container;

  return (
    <Wrapper sx={sx}>
      <Box sx={{ gridAutoFlow: 'row', rowGap: { xs: 2, md: 1 }, columnGap: 4 }} display="grid" gridTemplateColumns={{ xs: 'auto', md: '1fr 1fr' }}>
        <Box component="h1" sx={{ m: 0, typography: 'h1', maxWidth: 630, ...subtitleStyle }} gridColumn="1">
          {title}
        </Box>
        {subtitle && (
          <Box component="h2" gridColumn={{ xs: '1', md: '2' }} gridRow="span 3" sx={{ m: 0, maxWidth: 630, ...subtitleStyle }}>
            {subtitle}
          </Box>
        )}
        {backButtonSlot && <Box gridColumn="1">{backButtonSlot}</Box>}
      </Box>
    </Wrapper>
  );
};

export default SplitPageTitle;
